export type UserState = {
  isLoggedIn: boolean,
};

const defaultState: UserState = {
  isLoggedIn: false,
};

const user = (state = defaultState, action: {type: string}) => {
  switch (action.type) {
    case 'LOGIN_USER':
      return {
        ...state,
        isLoggedIn: true,
      };
    case 'LOGOUT_USER': {
      return {
        ...state,
        isLoggedIn: false,
      };
    }
    default:
      return state;
  }
};

export default user;
